import {SharedInitGuard} from '@shared/guards/shared-init.guard';
import { Component, OnInit, inject } from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {Storage} from "@ionic/storage-angular";
import {Store} from "@ngrx/store";
import {appInit} from "@core/store/core-app.actions";
import {environment as linkEnv} from "@env-link/environment";
import {SharedLanguageService} from "@shared/services/shared-language.service";
import {CoreEnvironmentService} from "@core/services/environment/core-environment.service";
import {SharedLoginActions} from "@shared/components/login/store/shared-login.actions-type";
import {EAppType} from "@shared/models/AppType.enum";

// Init the CoreEnvironmentService with the LINK app environment variables
CoreEnvironmentService.setEnvironment(linkEnv);

@Component({
  selector: 'app-root',
  templateUrl: 'link-app.component.html',
  styleUrls: ['link-app.component.scss'],
  standalone: true,
  imports: [IonicModule]
})
export class LinkAppComponent implements OnInit {
  private _storage = inject(Storage);
  private _store = inject(Store);
  private _languageService = inject(SharedLanguageService);



  constructor() {
    inject(SharedInitGuard);
    // Set app type
    this._store.dispatch(SharedLoginActions.setAppType({ appType: EAppType.Link }));
    // Get the default language
    const environment = CoreEnvironmentService.getEnvironment();
    this._languageService.setDefaultLanguageByEnvironment(environment);
  }

  async ngOnInit() {
    this._store.dispatch(appInit());
    await this._storage.create();
  }
}
